// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"228":"947b3c35","231":"670cd101","321":"852af139","379":"0fdb8a9e","634":"7379dc06"}[chunkId] + ".js";
};